import * as React from "react"
import {Grid, Skeleton, useTheme} from "@mui/material";
import {generateArrayByNumber} from "@ui-seeker/utils"


export default function SkuDetailsStockSkeleton() {

	return <Grid container spacing={2}>
		{ generateArrayByNumber(4).map((_, idx) => <Grid item key={idx} xs={12} md={3}>
			<Skeleton variant="rectangular" height={150} />
		</Grid>) }
	</Grid>
}